import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { FeatureAccessService } from './feature-access.service';

export const superAdminGuard: CanActivateFn = () => {
  const svc = inject(FeatureAccessService);
  const router = inject(Router);
  return svc.isSuperAdmin() ? true : router.createUrlTree(['/']);
};
